import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { AppBar, Box, IconButton, Toolbar } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { MAX_WIDTH_CONTAINER_NotImprotant, UUID } from '../../config/cacheKey';
import './appBar.css';
import { RootState } from '../../redux/store';
import PersonIcon from '@mui/icons-material/Person';
import { useNavigate } from 'react-router-dom';
import { getpervStateTab } from '../../redux/loansTab/loansTabSlice';
import { setUnAuthorizedState } from '../../redux/unAuthorizedState/unAuthorizedStateSlice';
import { useCallback, useEffect } from 'react';


const UnauthorizedAppbar = () => {
    const dispatch = useDispatch();

    const navigate = useNavigate();
    const title = useSelector((state: RootState) => state.unauthorizedHeaderTitleSlice.header);
    const parentRoute = useSelector((state: RootState) => state.unauthorizedHeaderTitleSlice.parentRoute);
    const handlePrev = () => {
        if (parentRoute != null) {
            dispatch(getpervStateTab({ prevState: parentRoute }))
        }
    }

    const goToLogin = () => {
        dispatch(setUnAuthorizedState({ state: `login ${UUID}` }));
    }

    const pushStateToHistory = useCallback(() => {
        if (window.history.state === null || window.history.state.routeType !== parentRoute) {
            window.history.pushState({ parentRoute }, '', window.location.href);
        }
    }, [parentRoute]);

    const handlePopState = (event: any) => {
        event.preventDefault();

        if (window.history.state === null || (window.history.state.routeType === "" && window.history.state.innerBack === "")) {
            pushStateToHistory();
        } else {
            handlePrev();
        }
    };

    useEffect(() => {
        pushStateToHistory();

        window.addEventListener('popstate', handlePopState);

        return () => {
            window.removeEventListener('popstate', handlePopState);
        };
    }, [pushStateToHistory]);


    return (
        <>
            <Box sx={{ pb: '63px' }}>
                <AppBar
                    sx={{
                        // maxWidth: MAX_WIDTH_CONTAINER_NotImprotant,
                        background: "#fff",
                        borderLeft: "1px solid #e5e7eb",
                        borderRight: "1px solid #e5e7eb",
                        borderBottom: "#fff",
                        '@media (min-width: 550px)': {

                            background: 'var(--header-color)',

                        },

                    }}
                    className="appBarBackground appbarMedia containerMedia"
                    elevation={3}
                >
                    <Toolbar sx={{ alignItems: "center", height: "100%" }}>


                        <div className="appBarTitle">
                            {parentRoute == null ?
                                <div style={{ display: "flex" }}>
                                    <img src='images/appbarIcon.png' style={{ paddingLeft: "5px", width: "20px", height: "20px" }}></img>
                                    <span className="font-bold text-sm primaryColorLight-900" style={{ fontSize: "15px", color: '#0057CC', alignSelf: "center" }}>{title}</span>
                                </div>
                                : <span className="font-bold text-sm   primaryColorLight-200">{title}</span>}

                        </div>
                        {parentRoute != null ? <IconButton
                            edge="start"
                            color="inherit"
                            className="appBarBackBtn, primaryColorLight-200"
                            onClick={handlePrev}
                        >
                            <ArrowBackIcon />
                        </IconButton>
                            : <div style={{ display: "flex", padding: "2px 7px 2px 5px" }} onClick={goToLogin}>
                                <span className="font-bold text-sm " style={{ fontSize: "15px", paddingTop: "3px", color: '#0057CC' }}>ورود/ثبت نام</span>
                                {/* <PersonIcon style={{ color: "#0057CC" }}></PersonIcon> */}
                            </div>}
                    </Toolbar>
                </AppBar>
            </Box>
            {/* <hr className="separator" /> */}
        </>
    );
};
export default UnauthorizedAppbar;
